import { FilterIcon } from '@primer/octicons-react';
import { AnchoredOverlay, Box, Octicon } from '@primer/react';
import { ICondition, IDataGridColumn } from '../type/IDataGridProps';
import { useEffect, useMemo, useState } from 'react';
import HeaderFilterModal from './HeaderFilterModal';
interface IHeaderFilterButtonProps {
    conditions: ICondition[],
    dataSource: any[];
    dataColumn: IDataGridColumn;
    onApply: (values: any[]) => void,
}
const HeaderFilterButton = ({ dataSource, dataColumn, onApply, conditions }: IHeaderFilterButtonProps) => {
    const [isOpenFilterModal, setIsOpenFilterModal] = useState(false);
    const [distinctedValues, setDistinctedValues] = useState<any[]>();
    useEffect(() => {
        setDistinctedValues(undefined)
    }, [dataColumn, dataSource])
    const handleFilterClick = () => {
        setIsOpenFilterModal(true)
        if (distinctedValues === undefined)
            handleGetDistinctValue();
    }
    const handleGetDistinctValue = () => {
        if (dataSource && dataColumn.dataField) {
            const values = Array.from(new Set(dataSource.map(x => x[dataColumn.dataField ?? ""])));
            setDistinctedValues(values)
        }
    }
    const condition = useMemo(() => {
        return conditions.find(x => x.field === dataColumn.dataField)
    }, [conditions, dataColumn])
    

    return (
        <Box>
            <AnchoredOverlay
                open={isOpenFilterModal}
                onClose={() => {
                    setIsOpenFilterModal(false)
                }}
                overlayProps={{
                    role: 'dialog',
                    'aria-modal': true,
                    'aria-label': 'Preview',

                }}
                focusZoneSettings={{
                    disabled: true
                }}
                side="outside-bottom"
                align="start"
                renderAnchor={(anchorProps) => {

                    return (
                        <Box
                            {...anchorProps}
                            onClick={() => {
                                handleFilterClick()
                            }}
                            sx={{
                                cursor:"pointer"
                            }}
                        >
                            <Octicon icon={FilterIcon} size={"small"}
                                sx={{
                                    color: condition ? "accent.emphasis" : undefined,
                                    width:"0.9rem"
                                }}
                            />
                        </Box>
                    );
                }}

            >
                <HeaderFilterModal
                    condition={condition}
                    dataColumn={dataColumn}
                    distinctedValues={distinctedValues ?? []}
                    onApply={(values) => {
                        onApply(values)
                        setIsOpenFilterModal(false)
                    }}
                    onCancel={() => {
                        setIsOpenFilterModal(false)
                    }}
                />
            </AnchoredOverlay >

        </Box>
    );
};

export default HeaderFilterButton;